import { imageUrl } from '@/utils/assets';

export const creatorCategories = [
  'Beauty & Skincare',
  'Fashion',
  'Lifestyle',
  'Food & Recipes',
  'Fitness & Wellness',
  'Tech & Fintech',
  'Music & Entertainment',
  'Travel',
  'Parenting',
  'Home & Interiors',
  'Sports',
  'Heritage & Culture',
];

export const creatorPlatforms = ['TikTok', 'Instagram', 'YouTube', 'X', 'Facebook'];

export const followerTiers = [
  { id: 'nano', label: 'Nano', hint: 'under 10K' },
  { id: 'micro', label: 'Micro', hint: '10K – 50K' },
  { id: 'mid', label: 'Mid', hint: '50K – 250K' },
  { id: 'macro', label: 'Macro', hint: '250K – 1M' },
  { id: 'mega', label: 'Mega', hint: '1M+' },
];

export const creators = [
  {
    id: 'crt-zawadi',
    name: 'Zawadi Mwangi',
    handle: '@zawadiskin',
    avatar: imageUrl('creators/crt-zawadi.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya'],
    categories: ['Beauty & Skincare', 'Lifestyle'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'TikTok', handle: '@zawadiskin', followers: 61200, engagementRate: 7.4, avgViews: 148000, verified: true },
      { platform: 'Instagram', handle: '@zawadiskin', followers: 23100, engagementRate: 6.1, avgViews: 41000, verified: true },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'instagram-story', 'tiktok-video'],
    followers: 84300,
    engagementRate: 6.8,
    rate: 96000,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 86, men: 14, topAge: '20-34', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 84300 }],
    brandSafety: 'Clear',
    responseTime: 'Within 2 hours',
    agencyHistory: { campaigns: 6, onTimeRate: 92, rating: 4.8 },
    fitScore: 96,
    reasonCodes: ['Skincare category match', 'Kenya coverage', 'Proven high engagement', 'Within budget'],
    riskFlags: [],
    bio: 'Skincare-first creator building routines for everyday African skin. Known for honest, tutorial-led reviews and a highly engaged micro community.',
  },
  {
    id: 'crt-sanaa',
    name: 'Sanaa Njeri',
    handle: '@sanaacooks',
    avatar: imageUrl('creators/crt-sanaa.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya'],
    categories: ['Food & Recipes', 'Lifestyle'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'TikTok', handle: '@sanaacooks', followers: 28400, engagementRate: 8.2, avgViews: 96000, verified: true },
      { platform: 'Instagram', handle: '@sanaacooks', followers: 5400, engagementRate: 6.6, avgViews: 12000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'tiktok-video', 'blog-post'],
    followers: 33800,
    engagementRate: 7.4,
    rate: 42000,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 72, men: 28, topAge: '25-44', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 33800 }],
    brandSafety: 'Clear',
    responseTime: 'Within 4 hours',
    agencyHistory: { campaigns: 11, onTimeRate: 96, rating: 4.9 },
    fitScore: 94,
    reasonCodes: ['Recipe & grocery fit', 'Consistent weekly output', 'Strong saves & shares', 'Excellent delivery record'],
    riskFlags: [],
    bio: 'Weekly recipe and grocery-haul creator with a reputation for repeatable, format-friendly content that converts casual viewers into first-time buyers.',
  },
  {
    id: 'crt-neema',
    name: 'Neema Achieng',
    handle: '@neematalksmoney',
    avatar: imageUrl('creators/crt-neema.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya', 'Uganda'],
    categories: ['Tech & Fintech', 'Lifestyle'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'YouTube', handle: '@neematalksmoney', followers: 74500, engagementRate: 4.3, avgViews: 88000, verified: true },
      { platform: 'TikTok', handle: '@neematalksmoney', followers: 34200, engagementRate: 5.4, avgViews: 61000, verified: true },
      { platform: 'X', handle: '@neemamoney', followers: 19300, engagementRate: 3.1, avgViews: 22000, verified: true },
    ],
    contentFormats: ['youtube-video', 'youtube-shorts', 'tiktok-video', 'x-post', 'linkedin-post'],
    followers: 128000,
    engagementRate: 4.1,
    rate: 130000,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC incomplete',
    walletStatus: 'Wallet active',
    audience: { women: 58, men: 42, topAge: '25-34', topMarket: 'Kenya' },
    marketAudience: [
      { market: 'Kenya', followers: 84000 },
      { market: 'Uganda', followers: 44000 },
    ],
    brandSafety: 'Clear',
    responseTime: 'Within 1 day',
    agencyHistory: { campaigns: 3, onTimeRate: 88, rating: 4.5 },
    fitScore: 90,
    reasonCodes: ['Fintech explainer specialist', 'Multi-platform reach', 'Trusted for money topics'],
    riskFlags: ['KYC incomplete'],
    bio: 'Personal-finance educator making wallets, savings and payments make sense to a young urban audience. Long-form explainers with unusually high watch-through.',
  },
  {
    id: 'crt-jabari',
    name: 'Jabari Kimani',
    handle: '@jabariwell',
    avatar: imageUrl('creators/crt-jabari.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya'],
    categories: ['Fitness & Wellness', 'Fitness & Wellness'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'YouTube', handle: '@jabariwell', followers: 58200, engagementRate: 6.2, avgViews: 74000, verified: true },
      { platform: 'Instagram', handle: '@jabariwell', followers: 38300, engagementRate: 5.6, avgViews: 46000, verified: true },
    ],
    contentFormats: ['youtube-video', 'youtube-shorts', 'instagram-reel', 'instagram-post'],
    followers: 96500,
    engagementRate: 5.9,
    rate: 88000,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet inactive',
    audience: { women: 47, men: 53, topAge: '22-40', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 96500 }],
    brandSafety: 'Clear',
    responseTime: 'Within 6 hours',
    agencyHistory: { campaigns: 5, onTimeRate: 90, rating: 4.6 },
    fitScore: 87,
    reasonCodes: ['Health & wellness match', 'Strong long-form retention', 'Reliable weekly cadence'],
    riskFlags: ['Wallet inactive'],
    bio: 'Wellness creator covering training, recovery and everyday health habits. Prefers explainer formats that pair well with awareness objectives.',
  },
  {
    id: 'crt-halima',
    name: 'Halima Yusuf',
    handle: '@halimaheritage',
    avatar: imageUrl('creators/crt-halima.webp'),
    city: 'Dar es Salaam, Tanzania',
    markets: ['Tanzania', 'Kenya'],
    categories: ['Beauty & Skincare', 'Heritage & Culture'],
    languages: ['Swahili', 'English'],
    platforms: [
      { platform: 'Instagram', handle: '@halimaheritage', followers: 142000, engagementRate: 4.9, avgViews: 132000, verified: true },
      { platform: 'YouTube', handle: '@halimaheritage', followers: 68400, engagementRate: 4.2, avgViews: 71000, verified: true },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'instagram-story', 'youtube-video', 'blog-post'],
    followers: 210000,
    engagementRate: 4.6,
    rate: 4200000,
    currency: 'TZS',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 81, men: 19, topAge: '25-44', topMarket: 'Tanzania' },
    marketAudience: [
      { market: 'Tanzania', followers: 132000 },
      { market: 'Kenya', followers: 78000 },
    ],
    brandSafety: 'Clear',
    responseTime: 'Within 1 day',
    agencyHistory: { campaigns: 7, onTimeRate: 94, rating: 4.7 },
    fitScore: 88,
    reasonCodes: ['Heritage storytelling fit', 'Tanzania + Kenya coverage', 'Cinematic long-form'],
    riskFlags: [],
    bio: 'Beauty and heritage storyteller producing cinematic long-form pieces about African beauty rituals, craft and identity.',
  },
  {
    id: 'crt-tunde',
    name: 'Tunde Bakari',
    handle: '@tundebeats',
    avatar: imageUrl('creators/crt-tunde.webp'),
    city: 'Dar es Salaam, Tanzania',
    markets: ['Tanzania'],
    categories: ['Music & Entertainment'],
    languages: ['Swahili', 'English'],
    platforms: [
      { platform: 'TikTok', handle: '@tundebeats', followers: 318000, engagementRate: 3.6, avgViews: 512000, verified: true },
      { platform: 'Instagram', handle: '@tundebeats', followers: 194000, engagementRate: 2.9, avgViews: 168000, verified: true },
    ],
    contentFormats: ['tiktok-video', 'instagram-reel', 'instagram-story'],
    followers: 512000,
    engagementRate: 3.2,
    rate: 6800000,
    currency: 'TZS',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 54, men: 46, topAge: '18-29', topMarket: 'Tanzania' },
    marketAudience: [{ market: 'Tanzania', followers: 512000 }],
    brandSafety: 'Clear',
    responseTime: 'Within 2 days',
    agencyHistory: { campaigns: 4, onTimeRate: 82, rating: 4.3 },
    fitScore: 79,
    reasonCodes: ['Festival hype reach', 'Massive TikTok distribution', 'Music-audience overlap'],
    riskFlags: ['Occasional late delivery'],
    bio: 'Music and nightlife creator with the biggest raw TikTok reach in the region. Best for scale and hype moments rather than niche conversion.',
  },
  {
    id: 'crt-amina-k',
    name: 'Amina Kessy',
    handle: '@aminakessy',
    avatar: imageUrl('creators/crt-aminak.webp'),
    city: 'Kinshasa, DR Congo',
    markets: ['DR Congo'],
    categories: ['Fashion', 'Lifestyle'],
    languages: ['French', 'Lingala', 'English'],
    platforms: [
      { platform: 'Instagram', handle: '@aminakessy', followers: 118000, engagementRate: 5.1, avgViews: 96000, verified: true },
      { platform: 'TikTok', handle: '@aminakessy', followers: 38000, engagementRate: 6.4, avgViews: 72000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-story', 'instagram-reel', 'tiktok-video'],
    followers: 156000,
    engagementRate: 4.8,
    rate: 1650,
    currency: 'USD',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 76, men: 24, topAge: '22-38', topMarket: 'DR Congo' },
    marketAudience: [{ market: 'DR Congo', followers: 156000 }],
    brandSafety: 'Clear',
    responseTime: 'Within 1 day',
    agencyHistory: { campaigns: 2, onTimeRate: 91, rating: 4.6 },
    fitScore: 85,
    reasonCodes: ['Strongest Kinshasa fashion reach', 'Lifestyle brand fit', 'Growing TikTok presence'],
    riskFlags: [],
    bio: 'Fashion and lifestyle creator shaping Kinshasa street style, with a bilingual audience ideal for premium lifestyle launches.',
  },
  {
    id: 'crt-david',
    name: 'David Mwansa',
    handle: '@davidgoes',
    avatar: imageUrl('creators/crt-david.webp'),
    city: 'Kampala, Uganda',
    markets: ['Uganda', 'Kenya'],
    categories: ['Travel', 'Lifestyle'],
    languages: ['English', 'Luganda'],
    platforms: [
      { platform: 'Instagram', handle: '@davidgoes', followers: 41200, engagementRate: 5.7, avgViews: 52000, verified: true },
      { platform: 'YouTube', handle: '@davidgoes', followers: 20000, engagementRate: 5.0, avgViews: 34000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-story', 'youtube-video', 'blog-post'],
    followers: 61200,
    engagementRate: 5.5,
    rate: 2100000,
    currency: 'UGX',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 49, men: 51, topAge: '24-40', topMarket: 'Uganda' },
    marketAudience: [
      { market: 'Uganda', followers: 39800 },
      { market: 'Kenya', followers: 21400 },
    ],
    brandSafety: 'Clear',
    responseTime: 'Within 8 hours',
    agencyHistory: { campaigns: 4, onTimeRate: 93, rating: 4.7 },
    fitScore: 83,
    reasonCodes: ['Uganda market coverage', 'Destination storytelling', 'Reliable mid-tier delivery'],
    riskFlags: [],
    bio: 'Travel creator documenting East African destinations with a documentary-lite style that suits consideration-driven campaigns.',
  },
  {
    id: 'crt-furaha',
    name: 'Furaha Salim',
    handle: '@furahamama',
    avatar: imageUrl('creators/crt-furaha.webp'),
    city: 'Mombasa, Kenya',
    markets: ['Kenya'],
    categories: ['Parenting', 'Fitness & Wellness'],
    languages: ['Swahili', 'English'],
    platforms: [
      { platform: 'Instagram', handle: '@furahamama', followers: 18400, engagementRate: 8.6, avgViews: 21000, verified: false },
      { platform: 'TikTok', handle: '@furahamama', followers: 6500, engagementRate: 7.1, avgViews: 14000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'instagram-story', 'tiktok-video'],
    followers: 24900,
    engagementRate: 8.1,
    rate: 32000,
    currency: 'KES',
    verification: 'Pending review',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 89, men: 11, topAge: '25-40', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 24900 }],
    brandSafety: 'Clear',
    responseTime: 'Within 3 hours',
    agencyHistory: { campaigns: 8, onTimeRate: 97, rating: 4.9 },
    fitScore: 84,
    reasonCodes: ['Highest engagement tier', 'Parenting community trust', 'Very cost-efficient'],
    riskFlags: [],
    bio: 'Parenting and wellness creator with one of the most engaged nano communities on the platform. Ideal for trust-led health messaging.',
  },
  {
    id: 'crt-grace',
    name: 'Grace Wambui',
    handle: '@graceathome',
    avatar: imageUrl('creators/crt-grace.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya'],
    categories: ['Home & Interiors', 'Lifestyle'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'Instagram', handle: '@graceathome', followers: 52300, engagementRate: 5.3, avgViews: 58000, verified: true },
      { platform: 'YouTube', handle: '@graceathome', followers: 20100, engagementRate: 4.6, avgViews: 33000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'youtube-video', 'blog-post'],
    followers: 72400,
    engagementRate: 5.0,
    rate: 76000,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 78, men: 22, topAge: '27-45', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 72400 }],
    brandSafety: 'Clear',
    responseTime: 'Within 5 hours',
    agencyHistory: { campaigns: 5, onTimeRate: 95, rating: 4.8 },
    fitScore: 82,
    reasonCodes: ['Premium home aesthetic', 'Considered purchase audience', 'High production quality'],
    riskFlags: [],
    bio: 'Home and interiors creator with a calm, premium aesthetic and an audience actively investing in their living spaces.',
  },
  {
    id: 'crt-emmanuel',
    name: 'Emmanuel Okello',
    handle: '@emmasports',
    avatar: imageUrl('creators/crt-emmanuel.webp'),
    city: 'Kampala, Uganda',
    markets: ['Uganda'],
    categories: ['Sports', 'Music & Entertainment'],
    languages: ['English', 'Luganda'],
    platforms: [
      { platform: 'TikTok', handle: '@emmasports', followers: 268000, engagementRate: 4.1, avgViews: 340000, verified: true },
      { platform: 'X', handle: '@emmasports', followers: 72000, engagementRate: 3.4, avgViews: 88000, verified: true },
    ],
    contentFormats: ['tiktok-video', 'x-post', 'instagram-reel'],
    followers: 340000,
    engagementRate: 3.9,
    rate: 4200000,
    currency: 'UGX',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 38, men: 62, topAge: '18-34', topMarket: 'Uganda' },
    marketAudience: [{ market: 'Uganda', followers: 340000 }],
    brandSafety: 'Clear',
    responseTime: 'Within 1 day',
    agencyHistory: { campaigns: 3, onTimeRate: 85, rating: 4.4 },
    fitScore: 76,
    reasonCodes: ['Large Uganda sports reach', 'Live-event amplification', 'Young male audience'],
    riskFlags: ['Occasional late delivery'],
    bio: 'Sports and entertainment creator covering match-day culture and fan moments, with strong live-event amplification.',
  },
  {
    id: 'crt-brian',
    name: 'Brian Otieno',
    handle: '@brianweekends',
    avatar: imageUrl('creators/crt-brian.webp'),
    city: 'Nairobi, Kenya',
    markets: ['Kenya'],
    categories: ['Lifestyle', 'Music & Entertainment'],
    languages: ['English', 'Swahili'],
    platforms: [
      { platform: 'Instagram', handle: '@brianweekends', followers: 26800, engagementRate: 6.3, avgViews: 34000, verified: true },
      { platform: 'TikTok', handle: '@brianweekends', followers: 15300, engagementRate: 5.9, avgViews: 29000, verified: false },
    ],
    contentFormats: ['instagram-post', 'instagram-reel', 'tiktok-video', 'instagram-story'],
    followers: 42100,
    engagementRate: 5.2,
    rate: 74500,
    currency: 'KES',
    verification: 'Verified',
    kycStatus: 'KYC complete',
    walletStatus: 'Wallet active',
    audience: { women: 44, men: 56, topAge: '21-34', topMarket: 'Kenya' },
    marketAudience: [{ market: 'Kenya', followers: 42100 }],
    brandSafety: 'Clear',
    responseTime: 'Within 3 hours',
    agencyHistory: { campaigns: 9, onTimeRate: 89, rating: 4.5 },
    fitScore: 81,
    reasonCodes: ['Weekend lifestyle fit', 'Strong Reels performance', 'Reliable micro tier'],
    riskFlags: ['Deliverable missing'],
    bio: 'Weekend-lifestyle and entertainment creator known for punchy short-form Reels that travel well beyond the follower count.',
  },
];

export const savedLists = [
  {
    id: 'sl-q4-beauty',
    name: 'Q4 Beauty Pool — East Africa',
    creatorIds: ['crt-zawadi', 'crt-halima', 'crt-furaha'],
    updatedAt: '2026-09-08',
  },
  {
    id: 'sl-fintech',
    name: 'Fintech explainers',
    creatorIds: ['crt-neema', 'crt-david'],
    updatedAt: '2026-09-02',
  },
  {
    id: 'sl-kinshasa',
    name: 'Kinshasa market build',
    creatorIds: ['crt-amina-k'],
    updatedAt: '2026-09-11',
  },
];

export const discoveryPrompts = [
  'Skincare creators in Kenya',
  'Fintech explainers on YouTube',
];